import {
  faClock,
  faTicket,
  faHourglassHalf,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const iconMap = {
  "Total Tickets Worked on": faTicket,
  "Total Time": faClock,
  "Average Time per Ticket": faHourglassHalf,
};

const WorkSummaryV2 = ({ data }) => {
  return (
    <div className="p-6">
      <div className="flex flex-wrap justify-around gap-6">
        {data.map((item, index) => {
          const Icon = iconMap[item.label] || faTicket;

          // --- MAIN CARD (Total Tickets) ---
          if (item.isMain) {
            return (
              <div key={index} className="text-center flex-1 min-w-[160px]">
                <div className="p-4 rounded-full mb-3 mx-auto w-fit bg-gray-100">
                  <FontAwesomeIcon
                    icon={faTicket}
                    size={24}
                    style={{ color: "#144677" }}
                  />
                </div>
                <p className="text-sm font-semibold text-gray-600 mb-2">
                  {item.label}
                </p>
                <p className="text-3xl font-bold" style={{ color: "#144677" }}>
                  {item.value}
                </p>
              </div>
            );
          }

          // --- TOTAL TIME CARD ---
          if (item.isTotal) {
            return (
              <div key={index} className="text-center flex-1 min-w-[160px]">
                <div
                  className="p-3 rounded-lg mb-3 mx-auto w-fit"
                  style={{ backgroundColor: "rgba(255, 98, 102, 0.1)" }}
                >
                  <FontAwesomeIcon
                    icon={faClock}
                    size={20}
                    style={{ color: "#FF6266" }}
                  />
                </div>
                <p className="text-sm font-semibold text-gray-600 mb-2">
                  {item.label}
                </p>
                <p
                  className="text-2xl font-bold mb-1"
                  style={{ color: "#144677" }}
                >
                  {item.value}
                </p>
              </div>
            );
          }

          // --- AVERAGE TIME CARD (new) ---
          if (item.isAverage) {
            return (
              <div key={index} className="text-center flex-1 min-w-[160px]">
                <div className="p-3 rounded-lg mb-3 mx-auto w-fit bg-blue-50">
                  <FontAwesomeIcon
                    icon={faHourglassHalf}
                    size={20}
                    style={{ color: "#1a5c99" }}
                  />
                </div>

                <p className="text-sm font-semibold text-gray-600 mb-2">
                  {item.label}
                </p>

                <p
                  className="text-2xl font-bold mb-1"
                  style={{ color: "#144677" }}
                >
                  {item.value}
                </p>
              </div>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default WorkSummaryV2;
